webpackJsonp([56],{

/***/ "Q247":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/section-vertical-text-video_a9f6059dca4d20c6c5b356ae77315778.html";

/***/ }),

/***/ "oprM":
/***/ (function(module, exports, __webpack_require__) {

var SectionVerticalTextVideo = (function () {
    function SectionVerticalTextVideo() {
        this.bgStyle = this.bgStyle || 'gradient-wave';
    }
    return SectionVerticalTextVideo;
}());
angular.module('animatronApp.sectionVerticalTextVideo', []).component('sectionVerticalTextVideo', {
    bindings: {
        ltTitle: '<',
        description: '<',
        isDuration: '<?',
        buttons: '<',
        video: '<',
        isPlayBtn: '<',
        bgStyle: '@',
    },
    controller: SectionVerticalTextVideo,
    templateUrl: __webpack_require__("Q247")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/56-28dc41a6a889e793a2e2.min.js